export const validationInput = [
  {
    key: "grpName",
    type: "text"
  }
];
